import * as axios from "axios";

const baseUrlPath = "/8p2dm";

const headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  "Access-Control-Allow-Origin": "*",
};

// Anlagen
function getAnlagenList(filters) {
  const url = baseUrlPath + `/anlagen/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function getAnlage(idOrSeriennummer) {
  const url = baseUrlPath + `/anlagen/get`;
  return axios.post(url, { id: idOrSeriennummer }, headers).then((x) => x.data);
}

function createAnlage(anlage) {
  const url = baseUrlPath + `/anlagen/create`;
  return axios.post(url, { anlage: anlage }, headers).then((x) => x.data);
}

function updateAnlage(id, version, anlage) {
  const url = baseUrlPath + `/anlagen/update`;
  return axios.post(url, { id: id, version: version, anlage: anlage }, headers).then((x) => x.data);
}

function deleteAnlage(id) {
  const url = baseUrlPath + `/anlagen/delete`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

function confirmAnlage(id) {
  const url = baseUrlPath + `/anlagen/confirm`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

// Parks
function getParksList(filters) {
  const url = baseUrlPath + `/parks/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function getPark(id) {
  const url = baseUrlPath + `/parks/get`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

function createPark(park) {
  const url = baseUrlPath + `/parks/create`;
  return axios.post(url, { park: park }, headers).then((x) => x.data);
}

function updatePark(id, park) {
  const url = baseUrlPath + `/parks/update`;
  return axios.post(url, { id: id, park: park }, headers).then((x) => x.data);
}

function deletePark(id) {
  const url = baseUrlPath + `/parks/delete`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

// Adressen
function getAdressenList(filters) {
  const url = baseUrlPath + `/adressen/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function getAdresse(id) {
  const url = baseUrlPath + `/adressen/get`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

function createAdresse(adresse) {
  const url = baseUrlPath + `/adressen/create`;
  return axios.post(url, { adresse: adresse }, headers).then((x) => x.data);
}

function updateAdresse(id, adresse) {
  const url = baseUrlPath + `/adressen/update`;
  return axios.post(url, { id: id, adresse: adresse }, headers).then((x) => x.data);
}

function deleteAdresse(id) {
  const url = baseUrlPath + `/adressen/delete`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

// Pruefungsfristen
function getPruefungsfristen(anlageId) {
  const url = baseUrlPath + `/pruefungsfristen/get`;
  return axios.post(url, { anlage_id: anlageId }, headers).then((x) => x.data);
}

function addPruefung(anlageId, pruefung) {
  const url = baseUrlPath + `/pruefungsfristen/add`;
  return axios.post(url, { anlage_id: anlageId, pruefung: pruefung }, headers).then((x) => x.data);
}

function updatePruefung(anlageId, pruefungId, pruefung) {
  const url = baseUrlPath + `/pruefungsfristen/update`;
  return axios.post(url, { anlage_id: anlageId, pruefung_id: pruefungId, pruefung: pruefung }, headers).then((x) => x.data);
}

function getPruefungsfristenDashboard(filters) {
  const url = baseUrlPath + `/pruefungsfristen/dashboard`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

// Dokumente
function getDokumenteList(filters) {
  const url = baseUrlPath + `/dokumente/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function uploadDokument(formData) {
  const url = baseUrlPath + `/dokumente/upload`;
  return axios.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((x) => x.data);
}

function getDokumentDownloadUrl(id) {
  var token = localStorage.getItem("token") || "";
  return axios.defaults.baseURL + baseUrlPath + `/dokumente/download/` + id + `?token=` + encodeURIComponent(token);
}

function updateDokument(id, update) {
  const url = baseUrlPath + `/dokumente/update`;
  return axios.post(url, { id: id, update: update }, headers).then((x) => x.data);
}

function deleteDokument(id) {
  const url = baseUrlPath + `/dokumente/delete`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

// MaStR
function mastrImport(csvData, anlageTyp) {
  const url = baseUrlPath + `/mastr/import`;
  return axios.post(url, { csv_data: csvData, anlage_typ: anlageTyp }, headers).then((x) => x.data);
}

function mastrList(filters) {
  const url = baseUrlPath + `/mastr/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function mastrAccept(id, anlageId, felderMapping) {
  const url = baseUrlPath + `/mastr/accept`;
  return axios.post(url, { id: id, anlage_id: anlageId, felder_mapping: felderMapping }, headers).then((x) => x.data);
}

function mastrReject(id) {
  const url = baseUrlPath + `/mastr/reject`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

// Preislisten
function getPreislisteList(filters) {
  const url = baseUrlPath + `/preisliste/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

function getPreisliste(id) {
  const url = baseUrlPath + `/preisliste/get`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

function createPreisliste(preisliste) {
  const url = baseUrlPath + `/preisliste/create`;
  return axios.post(url, { preisliste: preisliste }, headers).then((x) => x.data);
}

function updatePreisliste(id, preisliste) {
  const url = baseUrlPath + `/preisliste/update`;
  return axios.post(url, { id: id, preisliste: preisliste }, headers).then((x) => x.data);
}

function freigebenPreisliste(id) {
  const url = baseUrlPath + `/preisliste/freigeben`;
  return axios.post(url, { id: id }, headers).then((x) => x.data);
}

function importPreisliste(file) {
  const url = baseUrlPath + `/preisliste/import`;
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(url, formData, { headers: { "x-access-token": localStorage.getItem("token"), "Content-Type": "multipart/form-data" } }).then((x) => x.data);
}

// Dashboard Overview
function getDashboardOverview() {
  const url = baseUrlPath + `/dashboard/overview`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

// Audit
function getAuditLog(filters) {
  const url = baseUrlPath + `/audit/list`;
  return axios.post(url, filters || {}, headers).then((x) => x.data);
}

// Import aus Inspektionen
function importInspectScan() {
  const url = baseUrlPath + `/import/inspect-scan`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

// Contractors
function syncContractors() {
  const url = baseUrlPath + `/import/sync-contractors`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

function migrateAuftragnehmer() {
  const url = baseUrlPath + `/import/migrate-auftragnehmer`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

function getContractorsList() {
  const url = baseUrlPath + `/anlagen/contractors`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

// Reset (nur Testumgebung)
function resetAll() {
  const url = baseUrlPath + `/reset/all`;
  return axios.post(url, {}, headers).then((x) => x.data);
}

// Integration
function integrationAutofill(seriennummer, inspectId) {
  const url = baseUrlPath + `/integration/autofill`;
  return axios.post(url, { seriennummer: seriennummer, inspect_id: inspectId }, headers).then((x) => x.data);
}

function integrationRefresh(seriennummer, inspectId) {
  const url = baseUrlPath + `/integration/refresh`;
  return axios.post(url, { seriennummer: seriennummer, inspect_id: inspectId }, headers).then((x) => x.data);
}

export {
  getAnlagenList,
  getAnlage,
  createAnlage,
  updateAnlage,
  deleteAnlage,
  confirmAnlage,
  getParksList,
  getPark,
  createPark,
  updatePark,
  deletePark,
  getAdressenList,
  getAdresse,
  createAdresse,
  updateAdresse,
  deleteAdresse,
  getPruefungsfristen,
  addPruefung,
  updatePruefung,
  getPruefungsfristenDashboard,
  getDokumenteList,
  getDokumentDownloadUrl,
  uploadDokument,
  updateDokument,
  deleteDokument,
  mastrImport,
  mastrList,
  mastrAccept,
  mastrReject,
  getPreislisteList,
  getPreisliste,
  createPreisliste,
  updatePreisliste,
  freigebenPreisliste,
  importPreisliste,
  getDashboardOverview,
  getAuditLog,
  importInspectScan,
  integrationAutofill,
  integrationRefresh,
  syncContractors,
  migrateAuftragnehmer,
  getContractorsList,
  resetAll,
};
